import React, { memo } from 'react';

import ContentZone from '@/components/Base/ContentZone';
import {
  CONTENT_POSITION_TYPES,
  CONTENT_POSITION_TYPES as CONTENT_POSITIONS,
} from '@/constants';
import { useGetContentBlocks } from '@/hooks';

import { Wrapper } from './HomePageFooter.styles';

const HomePageFooter = memo(() => {
  const {
    contentBlocks: {
      [CONTENT_POSITIONS.contentBottom]: bottomContent,
      [CONTENT_POSITION_TYPES.footerTop]: footerTopContent,
    },
  } = useGetContentBlocks();

  return (
    <Wrapper>
      <ContentZone
        content={bottomContent}
        position={CONTENT_POSITION_TYPES.contentBottom}
      />

      <ContentZone
        position={CONTENT_POSITION_TYPES.footerTop}
        content={footerTopContent}
      />
    </Wrapper>
  );
});

export default HomePageFooter;
